import { ReachAPI } from './ReachAPI';
import { Log } from '../AuxillaryService/Log';

/**
 * @class broadsign
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.broadsign = {};

/**
 * Request ads from Broadsign ad serving API via REACH API
 * @param {ReachAPI.Security} security
 * @param {number} widgetId
 * @param {number} width
 * @param {number} height
 * @param {boolean} allowAudio
 * @param {number} numberOfAds
 * @param {number} maxDurationInSeconds
 * @throws {ReachApiError}
 * @returns {Promise<ReachApiResponse>}
 * @memberof ReachAPI.broadsign
 */
ReachAPI.broadsign.requestAds = function (
    security,
    widgetId,
    width,
    height,
    allowAudio,
    numberOfAds,
    maxDurationInSeconds
) {
    var url = ReachAPI.server + '/signage/broadsign/request_ads/' + widgetId;
    var params = {};
    var jqPromise;

    params = {
        width: width,
        height: height,
        allow_audio: allowAudio,
        number_of_ads: numberOfAds,
        max_duration: maxDurationInSeconds,
        widget_id: widgetId,
    };

    params = security.merge(params);

    jqPromise = ReachAPI.post(url, params);

    jqPromise.done(function () {
        Log.Info('Requested broadsign ads via REACH api', null, __fileline);
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to request Broadsign ads via the REACH api',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return ReachAPI.deferredToPromise(jqPromise);
};

/**
 * Sends proof of play to Broadsign API via a
 * Broadsign proof of play url
 * @param {ReachAPI.Security} security
 * @param {string} proofOfPlayUrl
 * @param {number} widgetId
 * @throws {ReachApiError}
 * @returns {Promise<ReachApiResponse>}
 */
ReachAPI.broadsign.sendProofOfPlay = function (security, proofOfPlayUrl, widgetId) {
    var url = ReachAPI.server + '/signage/broadsign/send_proof_of_play/';
    var params = {};
    var jqPromise;
    params = {
        proof_of_play_url: proofOfPlayUrl,
        widget_id: widgetId,
    };

    params = security.merge(params);

    jqPromise = ReachAPI.get(url, 'json', params);

    jqPromise.done(function () {
        Log.Info('Succefully sent proof of play for Broadsign', null, __fileline);
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to send proof of play for a Broadsign ad via the REACH api',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return ReachAPI.deferredToPromise(jqPromise);
};
